import { LoadingButton } from "@mui/lab"

interface ISubmitProps {
    isFormValid?: boolean;
    shouldShowAuth?: boolean;
    isAuthRequired?: boolean;
    loading: boolean;
    handleSubmit: () => void;
    isModal?: boolean;
    isOtp?: boolean;
}

const Submit = ({isFormValid, shouldShowAuth, isAuthRequired, loading, handleSubmit, isModal, isOtp}: ISubmitProps) => {
  return (
    <LoadingButton
    variant="contained"
    disabled={!isFormValid || (shouldShowAuth && isAuthRequired)}
    loading={loading}
    onClick={handleSubmit}
    sx={{
      mt: 2,
      background: "rgb(25, 118, 210)",
      "&:hover": {
        background: "rgb(25, 118, 210)",
      },
      "&:focus": {
        background: "rgb(25, 118, 210)",
      },
      color: "white",
      alignSelf: "center",
    }}
  >
    {(isModal && isOtp) ? "Next" : isOtp ? "Verify" : "Submit"}
  </LoadingButton>
  )
}

export default Submit
